module.exports = __webpack_public_path__ + "static/media/bird_pick_sticks_page07.f22c4bf5.png";